import {ICustomerPickupEventHandler, PackageReleaseCodeConfirmedParameters,} from './ICustomerPickupEventHandler';
import {logger} from '../../logger';
import {ScanRequest, UpsRestClient} from "../../rest-clients/UpsRestClient";
import {DateTime} from "luxon";

const log = logger.sub("UpsCustomerPickupEventHandler");

export class UpsCustomerPickupEventHandler implements ICustomerPickupEventHandler {
    async packageReleaseCodeConfirmed(params: PackageReleaseCodeConfirmedParameters): Promise<void> {
        const { parcelId, backendApiCredentials, cubeId, packageReleaseCode, recipientName, signature } = params;
        log.info(`Called ups customer pickup package release code confirmed handler for ${parcelId}`);
        const { baseUrl, token } = backendApiCredentials;
        const upsRestClient = new UpsRestClient(baseUrl, token, cubeId);
        const request: ScanRequest = {
            event: 'CONSIGNEE_PICKUP',
            scanDateTime: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss.SSS'),
            trackingNumber: parcelId,
            epraPIN: packageReleaseCode,
            clarifiedSignature: "released with Storebox pin",
            digitalSignaturePoints: btoa(signature),
        };
        const response = await upsRestClient.sendScanEvent(request);
        if (!response.ok || !response.body.success) {
            throw new Error(JSON.stringify(response.body));
        }
    }
}